import { useEffect, useState } from 'react';
import { TEMAS, aplicarTema, guardarTema, temaGuardado, type Tema } from '../lib/tema.js';

/*
 * Elegir el tema del panel.
 *
 * Tres botones pegados en vez de un desplegable: son tres opciones cortas y
 * excluyentes, y asi se ve de un vistazo cual esta puesta sin abrir nada. En
 * una barra de 224px no caben tres palabras, de modo que cada uno lleva su
 * icono y su nombre accesible; el que esta activo si muestra el texto, que es
 * la unica etiqueta que hace falta leer.
 */
export function SelectorDeTema() {
  const [tema, setTema] = useState<Tema>(temaGuardado);

  useEffect(() => {
    aplicarTema(tema);
  }, [tema]);

  function elegir(nuevo: Tema) {
    guardarTema(nuevo);
    setTema(nuevo);
  }

  return (
    <div
      className="flex items-center gap-0.5 rounded-md border border-line bg-raise p-0.5"
      role="group"
      aria-label="Tema del panel"
    >
      {TEMAS.map(({ id, nombre }) => {
        const activo = id === tema;
        return (
          <button
            key={id}
            type="button"
            onClick={() => elegir(id)}
            aria-pressed={activo}
            title={nombre}
            className={`flex flex-1 items-center justify-center gap-1 rounded-sm px-1 py-1 text-[11.5px] transition-colors ${
              activo
                ? 'bg-surface text-ink shadow-[0_1px_2px_rgb(0_0_0/0.12)]'
                : 'text-ink-3 hover:text-ink-2'
            }`}
          >
            <Icono tema={id} />
            {/* El nombre solo en el activo: en el resto seria ruido y no cabe. */}
            <span className={activo ? '' : 'sr-only'}>{nombre}</span>
          </button>
        );
      })}
    </div>
  );
}

function Icono({ tema }: { tema: Tema }) {
  const comun = {
    width: 13,
    height: 13,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true,
  };

  if (tema === 'claro') {
    return (
      <svg {...comun}>
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
      </svg>
    );
  }
  if (tema === 'oscuro') {
    return (
      <svg {...comun}>
        <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
      </svg>
    );
  }
  // Sistema: una pantalla, que es el aparato que decide.
  return (
    <svg {...comun}>
      <rect x="2" y="4" width="20" height="13" rx="2" />
      <path d="M8 21h8M12 17v4" />
    </svg>
  );
}
